import { render } from "./GeneralAssemblyView.vue?vue&type=template&id=a39c2fa2&scoped=true"
import script from "./GeneralAssemblyView.vue?vue&type=script&lang=js"
export * from "./GeneralAssemblyView.vue?vue&type=script&lang=js"

import "./GeneralAssemblyView.vue?vue&type=style&index=0&id=a39c2fa2&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a39c2fa2"]])

export default __exports__